// extracted by mini-css-extract-plugin
export var aboutProgramPage__cards = "index-module--aboutProgramPage__cards--KyewK";
export var section4 = "index-module--section4--DR4d1";
export var section_3_bg = "index-module--section_3_bg--QpB24";
export var section_4_bg = "index-module--section_4_bg--PWrom";
export var section_5_bg = "index-module--section_5_bg--QoUtm";
export var section_6_bg = "index-module--section_6_bg--kOgNQ";
export var thankYouPage = "index-module--thankYouPage--ra43t";
export var thankYou__content = "index-module--thankYou__content--FfzJO";
export var thankYou__content__cont = "index-module--thankYou__content__cont--CqsX3";
export var thankYou__content__img = "index-module--thankYou__content__img--a2bR+";